/* eslint-disable import/export */
import antdTheme from './antd';
import { beltColor, beltForegroundColor } from './beltColor';
import { brandsColors } from './brands';
import { hexToRgba, spacing, pxToRem } from './utils';
import { mediaUtils } from '../mediaQuery';
const DEFAULT_PRIMARY_COLOR = '#0d2772';
const DEFAULT_SECONDARY_COLOR = '#FFBC00';
export default function createTheme(brand, variables) {
    var _a, _b;
    const brandColor = resolveBrandColor(brand);
    const base = {
        primaryColor: (_a = brandColor.primary) !== null && _a !== void 0 ? _a : DEFAULT_PRIMARY_COLOR,
        secondaryColor: (_b = brandColor.secondary) !== null && _b !== void 0 ? _b : DEFAULT_SECONDARY_COLOR,
        mediaQuery: mediaUtils,
        spacing: spacing,
        beltColor,
        beltForegroundColor,
        hexToRgba,
        pxToRem,
        components: {
            topBarHeight: 64
        },
        variables
    };
    return {
        light: Object.assign(Object.assign({ mode: 'light' }, base), { antd: antdTheme(brandColor, 'light') }),
        dark: Object.assign(Object.assign({ mode: 'dark' }, base), { antd: antdTheme(brandColor, 'dark') })
    };
}
function resolveBrandColor(brand) {
    if (typeof brand !== 'string' && typeof brand.primary === 'string' && typeof brand.secondary === 'string') {
        return brand;
    }
    return brandsColors[brand];
}
